// src/pages/BlogPage.jsx
import React from "react";

const blogs = [
   {
    title: "How to Self-Host n8n on AWS EC2 with SSL for Secure HTTPS Access",
    image: "https://miro.medium.com/v2/resize:fit:720/format:webp/1*cX2X7q2Zu8kb3hstDpRklQ.jpeg",
    link: "https://bibhu04.medium.com/how-to-self-host-n8n-on-aws-ec2-with-ssl-for-secure-https-access-1e6af30e57d3",
  },
  {
    title: "Role-Based Authentication Using AWS Cognito in a React Application",
    image: "https://miro.medium.com/v2/resize:fit:720/format:webp/1*I96HLo1bpCHZq_M0-n_bZA.png",
    link: "https://medium.com/@bibhu04/role-based-authentication-using-aws-cognito-in-a-react-application-34ab95f60d58",
  },
  {
    title: "Integrating AWS Cognito with React",
    image: "https://miro.medium.com/v2/resize:fit:720/format:webp/1*YpL1xjTfoqws0qa098MZ7w.png",
    link: "https://medium.com/@bibhu04/integrating-aws-cognito-with-react-5a4bc2326529",
  },
  {
    title: "DOCKER SWARM",
    image: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2Fed4nfm8ee11r0evbofdp.jpeg",
    link: "https://dev.to/bibhu_sunder/docker-swarm-3a2b",
  },
  {
    title: "APPLICATION MIGRATION IN AWS",
    image: "https://media2.dev.to/dynamic/image/width=1000,height=420,fit=cover,gravity=auto,format=auto/https%3A%2F%2Fdev-to-uploads.s3.amazonaws.com%2Fuploads%2Farticles%2F0ulvgv234me0yte19qqt.jpg",
    link: "https://dev.to/bibhu_sunder/application-migration-in-aws-31li",
  },
];

const BlogPage = () => {
  return (
    <div className="min-h-screen  px-4 sm:px-6 lg:px-12 py-10 bg-gradient-to-b from-blue-100 to-white h-[80vh]">
      <div className="prject-heading pt-2 pb-4">
        <h1 className="text-4xl font-bold text-center">My Blogs</h1>
        <div className="w-20 h-1 bg-blue-600 mx-auto mt-2 mb-2 rounded-full"></div>
      </div>

      {/* Responsive Grid */}
      <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {blogs.map((blog, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition transform hover:-translate-y-1 cursor-pointer flex flex-col"
            onClick={() => window.open(blog.link, "_blank")}
          >
            {/* Image container with aspect ratio */}
            <div className="w-full aspect-[16/9] overflow-hidden rounded-t-2xl">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-full object-cover hover:scale-105 transition-transform"
              />
            </div>

            {/* Blog content */}
            <div className="p-4 flex-1 flex items-center">
              <h2 className="text-base sm:text-lg font-semibold text-gray-800">
                {blog.title}
              </h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
